/**
 * @generated SignedSource<<069c67ccded678ecb42a0ce2fd470e73>>
 * @relayHash 8bfbe169b389a1e7204587b320193865
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 84bda087bbcb85556c465b27fc25c3d45b4dc9a60e60182e59bd0ba208af3063

import type { ConcreteRequest } from 'relay-runtime';
export type useSuggestedEditsUpdatedSubscription$variables = {
  id: string;
};
export type useSuggestedEditsUpdatedSubscription$data = {
  readonly confluence_onSuggestedEditsUpdated: {
    readonly __typename: "ConfluenceSuggestedEditsUpdated";
    readonly accountId: string | null;
  } | null;
};
export type useSuggestedEditsUpdatedSubscription = {
  response: useSuggestedEditsUpdatedSubscription$data;
  variables: useSuggestedEditsUpdatedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSuggestedEditsUpdatedSubscription",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceSuggestedEditsUpdated",
        "kind": "LinkedField",
        "name": "confluence_onSuggestedEditsUpdated",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ]
      }
    ],
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSuggestedEditsUpdatedSubscription",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceSuggestedEditsUpdated",
        "kind": "LinkedField",
        "name": "confluence_onSuggestedEditsUpdated",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8bfbe169b389a1e7204587b320193865",
    "id": "84bda087bbcb85556c465b27fc25c3d45b4dc9a60e60182e59bd0ba208af3063",
    "metadata": {},
    "name": "useSuggestedEditsUpdatedSubscription",
    "operationKind": "subscription",
    "text": "subscription useSuggestedEditsUpdatedSubscription($id:ID!){confluence_onSuggestedEditsUpdated(id:$id){accountId,__typename,id}}"
  }
};
})();

(node as any).hash = "8cd3bcd75594209560875934278358ea";

export default node;
